import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { SignIn } from './pages/SignIn';
import { Create } from './pages/Create';
import { Styles } from './pages/Styles';
import { Order } from './pages/Order';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { ContactUs } from './pages/ContactUs';
import { CreditSuccess } from './pages/CreditSuccess';

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-200 border-t-black"></div>
      </div>
    );
  }

  return (
    <Routes>
      {/* If user is logged in, "/" shows Create (the main app), otherwise Home */}
      <Route path="/" element={user ? <Create /> : <Home />} />
      
      {/* If user is logged in, redirect /signin to / */}
      <Route path="/signin" element={user ? <Navigate to="/" replace /> : <SignIn />} />
      
      {/* Public Routes */}
      <Route path="/styles" element={<Styles />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/contact-us" element={<ContactUs />} />

      {/* If user is NOT logged in, redirect protected routes to /signin or Home */}
      <Route path="/create" element={user ? <Create /> : <Navigate to="/signin" replace />} />
      <Route path="/order" element={user ? <Order /> : <Navigate to="/signin" replace />} />
      <Route path="/credits/success" element={user ? <CreditSuccess /> : <Navigate to="/signin" replace />} />
      <Route path="/payments/success" element={user ? <Order /> : <Navigate to="/signin" replace />} />
      <Route path="/history" element={user ? <div>History Page</div> : <Navigate to="/signin" replace />} />
      <Route path="/account" element={user ? <div>Account Page</div> : <Navigate to="/signin" replace />} />
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <AppRoutes />
          </Layout>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
